"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClassNameByPropNames = void 0;
/**
 * Concat given property names with className if the properties value is truthy.
 * @param props properties of a StyledComponent
 * @param propNames property names to be used as css classes if the property value is truthy
 * @returns css class names as string
 */
function generateClassNameByPropNames(props) {
    var _a;
    var propNames = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        propNames[_i - 1] = arguments[_i];
    }
    var className = '';
    for (var _b = 0, propNames_1 = propNames; _b < propNames_1.length; _b++) {
        var propName = propNames_1[_b];
        if (!props[propName]) {
            continue;
        }
        className += "".concat(propName, " ");
    }
    return className + ((_a = props.className) !== null && _a !== void 0 ? _a : '');
}
exports.generateClassNameByPropNames = generateClassNameByPropNames;
//# sourceMappingURL=util.js.map